// 1-день, 3-дня, 5-дней
export const declOfNum = (num: number, titles: string[]): string =>
  titles[num % 100 > 4 && num % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][num % 10 < 5 ? num % 10 : 5]]
